import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import MetricNumber from '../../common/metric-number';
import Diff from '../../common/diff';

const Type = styled.span`
  text-transform: uppercase;
  font: ${props => props.theme.fontWeightHeavy} 16px/120% ${props => props.theme.fontFamilyBody};
`;

const Tile = styled.div`
  padding: 40px 0;
  width: 175px;
  height: 160px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  color: ${props => props.theme.secondaryColor};
  border: none;
  border-bottom: 4px solid transparent;

  margin: 0 2px;
  &:first-child {
    margin-left: 0;
  }
  &:last-child {
    margin-right: 0;
  }

  ${props => props.clickable && (props.active ? `
    border-bottom-color: ${props.theme.bodyColor};
    & > span[class^="metric-number__"] {
      color: ${props.theme.bodyColor};
    }
  ` : `
    cursor: pointer;
    &:hover {
      border-bottom-color: ${props.theme.secondaryColor};
    }
  `)};
`;

const Stat = styled.div`
  display: flex;
  flex-direction: column;
  & > span[class^="metric-number__"] {
    color: ${props => props.theme.secondaryColor};
    font-size: 48px;
    line-height: 120%;
  }
  ${props => props.clickable && props.active && `
    & > span[class^="metric-number__"] {
      color: ${props.theme.bodyColor};
    }
  `};
  > .direction {
    flex-grow: 2;
    flex-basis: 50%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    > .row {
      padding-right: 4px;
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }

    > .row:not(.dir) {
      color: ${props => props.theme.secondaryColor};
    }
  }
`;

const Num = ({ n }) => {
  if (Number.isNaN(n) || !n) {
    return <span className="row" />;
  }

  return (
    <span className="row dir">
      <Diff value={n} large />
    </span>
  );
};

Num.propTypes = { n: PropTypes.number.isRequired };

export default function Total({
  type, number, previousPeriodNumber, active, onClick, clickable,
}) {
  const clickHandler = e => {
    e && e.preventDefault();
    if (clickable && !active) {
      onClick();
    }
  };

  const diff = number - previousPeriodNumber;

  return (
    <Tile active={active} clickable={clickable} onClick={clickHandler}>
      <Type>{type}</Type>
      <Stat active={active} clickable={clickable}>
        <MetricNumber n={number} />
        <div className="direction">
          <Num n={diff} />
        </div>
      </Stat>
    </Tile>
  );
}

Total.propTypes = {
  type: PropTypes.string.isRequired,
  number: PropTypes.number.isRequired,
  previousPeriodNumber: PropTypes.number.isRequired,
  active: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  clickable: PropTypes.bool.isRequired,
};
